import { render, staticRenderFns } from "./my_achievement.vue?vue&type=template&id=8bdb790e&"
import script from "./my_achievement.vue?vue&type=script&lang=js&"
export * from "./my_achievement.vue?vue&type=script&lang=js&"
import style0 from "./my_achievement.vue?vue&type=style&index=0&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports